import React, {Component} from "react";
import Select from "antd/lib/select";

class CustomerOwnerRelation extends Component<any, any> {
    private readonly initState!: any;

    constructor(props: any) {
        super(props);

        this.initState = {
            customerOwnerRelation: null,
        }
        this.state = {...this.initState}
    }

    onChange = (value: any, option: any) => {
        this.setState({
            customerOwnerRelation: value,
        });
        this.props.onCustomerOwnerRelationChangeProps(option);
    }

    render() {
        return (
            <Select
                placeholder="Hubungan Dengan Pemohon"
                showSearch
                optionFilterProp="children"
                onChange={this.onChange}
                filterOption={(input, option) =>
                    option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                value={this.props.value ?? this.state.customerOwnerRelation}
            >
                <Select.Option value="parents">orang tua</Select.Option>
                <Select.Option value="husband">suami</Select.Option>
                <Select.Option value="wife">istri</Select.Option>
                <Select.Option value="child">anak</Select.Option>
                <Select.Option value="another_family">anggota keluarga lainya</Select.Option>
                <Select.Option value="other">lainya</Select.Option>
            </Select>
        );
    }
}

export default CustomerOwnerRelation;
